var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.reasons),function(reason,index){return _c('p',{key:index,staticClass:"reason"},[_vm._v(" "+_vm._s(reason)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }